import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  FormGroup,
  Label,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap"
import { connect } from "react-redux"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
//i18n
import { withTranslation } from "react-i18next"
import { isEmpty, map, size } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteModal from "../../components/Common/DeleteModal";
import { addNewGoal, getAgentGoal, deleteAgentGoal } from "../../store/actions";
import CurrencyInput from "react-currency-input-field";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import axios from "axios";
import { API_URL } from "helpers/app_url";
import CurrencyFormat from "react-currency-format";
import backIcon from "../../assets/images/rsicons/backIcon.png"
import SafeField from "helpers/SafeField";
class ReportGoals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goal:'',
      applytoAll:'',
      jan: "",
      feb: "",
      mar: "",
      apr: "",
      may: "",
      jun: "",
      jul: "",
      aug: "",
      sep: "",
      oct: "",
      nov: "",
      dec: "",
      isGoalAdd :false
      
  };
    this.toggleAddGoalCanvas = this.toggleAddGoalCanvas.bind(this);
    this.toggleEditCanvas = this.toggleEditCanvas.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleAddGoal() {
    this.setState({ isAddGoal: !this.state.isAddGoal });

  }

toggleEditGoal() {
    this.setState({ isEditGoal: !this.state.isEditGoal });
}
  toggleDeleteModal = () => {
    this.setState(prevState => ({
        deleteModal: !prevState.deleteModal,
    }));
};
onClickDelete = (goal) => {
    this.setState({ goal: goal });
    this.setState({ deleteModal: true });
};

handleDeleteAgentGoal = () => {
    const { onDeleteAgentGoal } = this.props;
    const { goal } = this.state;

    if (goal.id !== undefined) {
        onDeleteAgentGoal(goal);
        this.setState({ deleteModal: false });
    }
};
  toggleAddGoalCanvas() {
    this.setState({  isGoalAdd: false, isAddGoal: !this.state.isAddGoal });
    this.toggleAddGoal();
  }
  componentDidMount() {
    const { onGetAgentGoal } = this.props;
    onGetAgentGoal(localStorage.getItem('userId'));
  }

  toggleEditCanvas() {
    this.setState({  isEdit: false, isEditGoal: !this.state.isEditGoal });
    this.toggleEditGoal();
  }
 toggleEditCanvas = arg => {
    const goal = arg;

    this.setState({
        goal: {
            id:goal.id,
            agentGoalId: goal.agentGoalId,
            agentId: goal.agentId,
            goalYear: goal.goalYear,
            goalCurrency: goal.goalCurrency,
            transactionCount: goal.transactionCount,
            percentageComission: goal.percentageComission,
            jan: goal.jan,
            feb: goal.feb,
            mar: goal.mar,
            apr: goal.apr,
            may: goal.may,
            jun: goal.jun,
            jul: goal.jul,
            aug: goal.aug,
            sep: goal.sep,
            oct: goal.oct,
            nov: goal.nov,
            dec: goal.dec,
            goalIsActive:goal.goalIsActive
      },
       isEdit: true,
        
    })
    this.toggleEditGoal();
 }
  render() {
    const { onAddGoal, goals, userdetail, onGetAgentGoal } = this.props;
    const { isGoalAdd, deleteModal, goal } = this.state;
    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    const months = [
        { key: "jan", label: "Jan" },
        { key: "feb", label: "Feb" },
        { key: "mar", label: "Mar" },
        { key: "apr", label: "Apr" },
        { key: "may", label: "May" },
        { key: "jun", label: "Jun" },
        { key: "jul", label: "Jul" },
        { key: "aug", label: "Aug" },
        { key: "sep", label: "Sep" },
        { key: "oct", label: "Oct" },
        { key: "nov", label: "Nov" },
        { key: "dec", label: "Dec" },
      ];
    return (
      <React.Fragment>
          {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
           <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteAgentGoal}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
         <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Create Template | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">
            {/* Render Breadcrumb */}

            <Row className="project-header">
              <Col sm="7">
                <Breadcrumbs
                  title={this.props.t("Report")}
                  breadcrumbItem={this.props.t("Goals")}
                />
              </Col>
              <Col sm="5">
              <Link
                  to="#" onClick={this.toggleAddGoalCanvas}
                  className="btn btn-light btn-md float-end mt-20"
                >
                  <i className="mdi mdi-plus-box-outline ms-1" /> {" "} Add goal
                </Link>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
               <Link to="/transaction">
                          <img
                            src={backIcon}
                            width="16px"
                            className="mdi mdi-home-import-outline ms-3"
                            style={{ marginTop: 10, marginBottom:10, cursor: "pointer" }}
                            alt="Back"
                          />
                        </Link>
                </Col>
            </Row>
            <Row>
              <Col sm="12">
                  <Card>
                    <CardBody>

                    <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
              <thead className="">
                <tr>
                  <th className="align-middle">Goal For</th>
                  <th className="align-middle">#Clients</th>
                  <th className="align-middle">Jan</th>
                  <th className="align-middle">Feb</th>
                  <th className="align-middle">Mar</th>
                  <th className="align-middle">Apr</th>
                  <th className="align-middle">May</th>
                  <th className="align-middle">Jun</th>
                  <th className="align-middle">Jul</th>
                  <th className="align-middle">Aug</th>
                  <th className="align-middle">Sep</th>
                  <th className="align-middle">Oct</th>
                  <th className="align-middle">Nov</th>
                  <th className="align-middle">Dec</th>
                  <th className="align-middle">Action</th>
                </tr>
              </thead>
                <tbody>
                {map(goals, (goal, goalkey) => (
                    <tr key={"_list_" + goalkey}>
                      <td>{goal.goalYear}</td>
                      <td>{goal.transactionCount}</td>
                      <td>

                        <CurrencyFormat
                          value={goal.jan}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        />
                      </td>
                      <td> <CurrencyFormat
                          value={goal.feb}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.mar}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.apr}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.may}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.jun}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.jul}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.aug}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.sep}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.oct}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.nov}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td> <CurrencyFormat
                          value={goal.dec}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={userdetail?.agentDefaultCurrencyCode + " "}
                        /></td>
                      <td>
                        <ActionEdit onClick={() => this.toggleEditCanvas(goal)} />

                        <ActionDelete onClick={() => this.onClickDelete(goal)}  />
             
                      </td>
                    </tr>
                 ))}
                </tbody>
            </table>

                    </CardBody>
                  </Card>
              </Col>
            </Row>

            <Row>
              <Col sm="4">

              </Col>
              <Col sm="4">
               
              </Col>
            </Row>

            <Offcanvas
          isOpen={this.state.isAddGoal}
          direction="end"
          toggle={this.toggleAddGoalCanvas}

        >
          <OffcanvasHeader toggle={this.toggleAddGoalCanvas}>
            Add New Goal
          </OffcanvasHeader>
          <OffcanvasBody>
          <Formik
                  enableReinitialize={true}
                  initialValues={{
                    agentId:parseInt(localStorage.getItem('userId')),
                    goalYear:  "",
                    transactionCount: (this.state && this.state.transactionCount) || "",
                     jan: "", feb: "", mar: "", apr: "",
                      may: "", jun: "", jul: "", aug: "",
                      sep: "", oct: "", nov: "", dec: "",
                    applytoAll: (this.state && this.state.applytoAll) || "",
                  }}

                  validationSchema={Yup.object().shape({
                    goalYear: Yup.string().required("This is required"),
                    //goalCurrency: Yup.string().required("This is required"),
                    transactionCount: Yup.string().required("This is required"),
                    
                    jan: Yup.string().required("This is required"),
                    feb: Yup.string().required("This is required"),     
                    mar: Yup.string().required("This is required"),    
                    apr: Yup.string().required("This is required"),  
                    may: Yup.string().required("This is required"), 
                    jun: Yup.string().required("This is required"), 
                    jul: Yup.string().required("This is required"),     
                    aug: Yup.string().required("This is required"),     
                    sep: Yup.string().required("This is required"),
                    oct: Yup.string().required("This is required"),  
                    nov: Yup.string().required("This is required"),     
                    dec: Yup.string().required("This is required"),     
                    //applytoAll: Yup.string(),     
                    
                  })}

                  onSubmit={values => {
                        onAddGoal(values, (status)=>{
                            if(status==true){
                              this.toggleAddGoal();
                            }
                        })
                     
                        
                }}
                
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >



          
                          <Row>


                            <Col sm="8">
                              <FormGroup className="mb-3">
                                <Label htmlFor="applytoAll">
                                  {this.props.t("Enter amount (apply for all months)")}
                                </Label>
                                <CurrencyInput
                                  name="applytoAll"
                                  type="text"
                                  onValueChange={(value) => setFieldValue('applytoAll', value)}
                                  className={
                                    "form-control" +
                                    (errors.applytoAll && touched.applytoAll
                                      ? " is-invalid"
                                      : "")
                                  }
                                  prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                  id="applytoAll"
                                />
                                <ErrorMessage
                                    name="applytoAll"
                                    component="div"
                                    className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>
                            <Col sm="4">
                               <button
                                  type="button"
                                  className="btn btn-primary w-md float-left"
                                  style={{ marginTop: 31 }}
                                  onClick={() => {
                                    const applyValue = values.applytoAll;
                                    //
                                    if (applyValue) {
                                      const months = [
                                        "jan", "feb", "mar", "apr", "may", "jun",
                                        "jul", "aug", "sep", "oct", "nov", "dec"
                                      ];
                                      months.forEach(month => {
                                        setFieldValue(month, applyValue);
                                      });
                                    }
                                  }}
                                >
                                  Apply
                                </button>
                            </Col>
                                  <Col sm="12" className="text-center mb-3">
                                      <span className="">OR set monthly goals</span>
                                  </Col>
                                 <Col sm="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="goalYear">
                                  {this.props.t("Goal For")}
                                </Label>
                                <SafeField as="select" name="goalYear" id="goalYear" onChange={handleChange}
                                   className={
                                    "form-control" +
                                    (errors.goalYear && touched.goalYear
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option value="">Select Year</option>
                                 {[currentYear, nextYear].map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                  ))}
                                </SafeField>
                                <ErrorMessage
                                    name="goalYear"
                                    component="div"
                                    className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>
                              
                            <Col sm="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="transactionCount">
                                  {this.props.t("# Clients")}
                                </Label>
                                <SafeField
                                  name="transactionCount"
                                  
                                  onValueChange={(value) => setFieldValue('transactionCount', value)}
                                  prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                  className={
                                    "form-control" +
                                    (errors.transactionCount && touched.transactionCount
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="jan"
                                />
                                 <ErrorMessage
                                    name="transactionCount"
                                    component="div"
                                    className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>
                           
                           {months.map((month) => (
                            <Col sm="6" key={month.key}>
                              <FormGroup className="mb-3">
                                <Label htmlFor={month.key}>{month.label}</Label>
                                <CurrencyInput
                                name={month.key}
                                value={values[month.key]}
                                className={
                                    "form-control" +
                                    (errors[month.key] && touched[month.key] ? " is-invalid" : "")
                                  }
                                onValueChange={(value) => setFieldValue(month.key, value)}
                                prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                decimalsLimit={2}
                              />
                              
                                <ErrorMessage
                                  name={month.key}
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                          ))}
                          </Row>

                          <div>
                                    <button type="submit" className="btn btn-primary w-md float-end">Save</button></div>          
                       
                    </Form>
                  )}
                </Formik>
          </OffcanvasBody>
        </Offcanvas>   


          <Offcanvas
          isOpen={this.state.isEditGoal}
          direction="end"
          toggle={this.toggleEditCanvas}

        >
          <OffcanvasHeader toggle={this.toggleEditCanvas}>
           Update Goal
          </OffcanvasHeader>
          <OffcanvasBody>
          <Formik
                  enableReinitialize={true}
                  initialValues={{
                    
                    id: goal?.id || "",
                    agentGoalId: goal?.agentGoalId || "",
                    agentId: goal?.agentId || "",
                    goalYear: goal?.goalYear || "",
                    goalCurrency: goal?.goalCurrency || "",
                    transactionCount: goal?.transactionCount || "",
                    percentageComission: goal?.percentageComission || 0,
                     jan: goal?.jan || "",
                    feb: goal?.feb || "",
                    mar: goal?.mar || "",
                    apr: goal?.apr || "",
                    may: goal?.may || "",
                    jun: goal?.jun || "",
                    jul: goal?.jul || "",
                    aug: goal?.aug || "",
                    sep: goal?.sep || "",
                    oct: goal?.oct || "",
                    nov: goal?.nov || "",
                    dec: goal?.dec || "",
                    applytoAll: "",
                  }}

                  validationSchema={Yup.object().shape({
                    goalYear: Yup.string().required("This is required"),
                    //goalCurrency: Yup.string().required("This is required"),
                    transactionCount: Yup.string().required("This is required"),
                    
                    jan: Yup.string().required("This is required"),
                    feb: Yup.string().required("This is required"),     
                    mar: Yup.string().required("This is required"),    
                    apr: Yup.string().required("This is required"),  
                    may: Yup.string().required("This is required"), 
                    jun: Yup.string().required("This is required"), 
                    jul: Yup.string().required("This is required"),     
                    aug: Yup.string().required("This is required"),     
                    sep: Yup.string().required("This is required"),
                    oct: Yup.string().required("This is required"),  
                    nov: Yup.string().required("This is required"),     
                    dec: Yup.string().required("This is required"),     
                    //applytoAll: Yup.string(),     
                    
                  })}

                 onSubmit={(values, { setSubmitting }) => {
                  const payload = {
                    ...values,
                    goalYear: parseInt(values.goalYear),
                    transactionCount: parseInt(values.transactionCount),
                    percentageComission: parseFloat(values.percentageComission),
                    jan: parseFloat(values.jan),
                    feb: parseFloat(values.feb),
                    mar: parseFloat(values.mar),
                    apr: parseFloat(values.apr),
                    may: parseFloat(values.may),
                    jun: parseFloat(values.jun),
                    jul: parseFloat(values.jul),
                    aug: parseFloat(values.aug),
                    sep: parseFloat(values.sep),
                    oct: parseFloat(values.oct),
                    nov: parseFloat(values.nov),
                    dec: parseFloat(values.dec)
                  };

                       const obj = JSON.parse(localStorage.getItem("authUser"));
                      const token = obj?.resultData?.bearerToken;
                      toast.loading('Please wait...')
                      axios.put(
                        `${API_URL}AgentGoal`,
                        payload,
                        {
                          headers: {
                            Authorization: `Bearer ${token}`,
                             "Content-Type": "application/json",
                          },
                        }
                      )
                      .then((response) => {
                        const res = response.data;
                        if(res.success){
                            toast.dismiss();
                            toast.success('Updated successfully.')
                            onGetAgentGoal(localStorage.getItem('userId'));
                            this.toggleEditGoal();
                        }else{
                           toast.dismiss();
                            toast.warn('Some error please try again')
 
                        }
                        
                      })
                      .catch((error) => {
                        // console.error("Update failed:", error);
                        // toast.error("Failed to update goal. Please try again.");
                      })
                      .finally(() => {
                        setSubmitting(false);
                      });
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >



          
                          <Row>


                            <Col sm="8">
                              <FormGroup className="mb-3">
                                <Label htmlFor="applytoAll">
                                  {this.props.t("Enter Amount (apply for all months)")}
                                </Label>
                                <CurrencyInput
                                  name="applytoAll"
                                  type="text"
                                  onValueChange={(value) => setFieldValue('applytoAll', value)}
                                  className={
                                    "form-control" +
                                    (errors.applytoAll && touched.applytoAll
                                      ? " is-invalid"
                                      : "")
                                  }
                                  prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                  id="applytoAll"
                                />
                                <ErrorMessage
                                    name="applytoAll"
                                    component="div"
                                    className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>
                            <Col sm="4">
                               <button
                                  type="button"
                                  className="btn btn-primary w-md float-left"
                                  style={{ marginTop: 31 }}
                                  onClick={() => {
                                    const applyValue = values.applytoAll;
                                    //
                                    if (applyValue) {
                                      const months = [
                                        "jan", "feb", "mar", "apr", "may", "jun",
                                        "jul", "aug", "sep", "oct", "nov", "dec"
                                      ];
                                      months.forEach(month => {
                                        setFieldValue(month, applyValue);
                                      });
                                    }
                                  }}
                                >
                                  Apply
                                </button>
                            </Col>
                                <Col sm="12" className="text-center mb-3">
                                      <span className="">OR</span>
                                  </Col>
                                 <Col sm="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="goalYear">
                                  {this.props.t("Goal For")}
                                </Label>
                                <SafeField as="select" name="goalYear" id="goalYear" onChange={handleChange}
                                   className={
                                    "form-control" +
                                    (errors.goalYear && touched.goalYear
                                      ? " is-invalid"
                                      : "")
                                  }
                                >
                                  <option value="">Select Year</option>
                                 {[currentYear, nextYear].map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                  ))}
                                </SafeField>
                                <ErrorMessage
                                    name="goalYear"
                                    component="div"
                                    className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>
                              
                            <Col sm="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="transactionCount">
                                  {this.props.t("# Clients")}
                                </Label>
                                <SafeField
                                  name="transactionCount"
                                  
                                  onValueChange={(value) => setFieldValue('transactionCount', value)}
                                  prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                  className={
                                    "form-control" +
                                    (errors.transactionCount && touched.transactionCount
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="jan"
                                />
                                 <ErrorMessage
                                    name="transactionCount"
                                    component="div"
                                    className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>
                           
                           {months.map((month) => (
                            <Col sm="6" key={month.key}>
                              <FormGroup className="mb-3">
                                <Label htmlFor={month.key}>{month.label}</Label>
                                <CurrencyInput
                                name={month.key}
                                value={values[month.key]}
                                className={
                                    "form-control" +
                                    (errors[month.key] && touched[month.key] ? " is-invalid" : "")
                                  }
                                onValueChange={(value) => setFieldValue(month.key, value)}
                                prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                decimalsLimit={2}
                              />
                              
                                <ErrorMessage
                                  name={month.key}
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                          ))}
                          </Row>

                          <div>
                                    <button type="submit" className="btn btn-primary w-md float-end">Update</button></div>          
                       
                    </Form>
                  )}
                </Formik>
          </OffcanvasBody>
        </Offcanvas>                       
          </Container>


        </div>
      </React.Fragment>
    )
  }



}


ReportGoals.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  onAddGoal:PropTypes.func,
  onGetAgentGoal:PropTypes.func,
  loading:PropTypes.object,
  goals:PropTypes.array,
  onDeleteAgentGoal:PropTypes.func,
  userdetail:PropTypes.object


}
const mapStateToProps = ({ Transaction }) => (
  {

    goals: Transaction.goals,
    loading: Transaction.loading

  })
const mapDispatchToProps = dispatch => ({
  onAddGoal: (data, callback) => dispatch(addNewGoal(data, callback)),
  onGetAgentGoal: (agentId) => dispatch(getAgentGoal(agentId)),
  onDeleteAgentGoal: (id) => dispatch(deleteAgentGoal(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReportGoals))